'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from '../../button/UIButton';
export default function CalendarFooterButton(props) {
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: "tertiary-light",
    size: "xs",
    responsive: false
  }, props));
}